import React, { useContext } from 'react'
import { GeneralContext } from 'contexts/General'
import { StyledLogo } from './styles'
import Image from '@/UI/Image'

const Logo = (props) => {
  const {
    options,
    page
  } = useContext(GeneralContext)

  const {
    logo,
    logoMobile
  } = options

  return (
    <StyledLogo href='/' darkMode={page.pageDarkTheme} aria-label={options.company} {...props}>
      <Image
        {...logo}
        className="desktop-logo"
        alt="Transmec"
        sizes="(max-width: 1300px) 180px, 540px"
        loading="eager"
        priority
      />
      <Image
        {...logoMobile}
        className="mobile-logo"
        alt="Transmec"
        sizes="(max-width: 768px) 156px"
        loading="eager"
        priority
      />
    </StyledLogo>
  )
}

export default Logo
